export const BLUE = '#1879BF'
export const RED = '#B81F25'
export const GREEN = '#2B9969'
